import { Box, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "source/components/framework/Dialog/Dialog";
import { DialogButtons } from "source/components/framework/Dialog/DialogButtons";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { IdTitleDropdown, IIdTitleDropdownItem } from "ui/Scripts/source/components/framework/Dropdown/IdTitleDropdown";

const rowItems = [{ id: "0", title: Translations.FirstListRow }, { id: "-1", title: Translations.LastListRow }];

export const getInitializeFromRowTextFromExpression = (expression: string, cols: ITaskTypeCol[]): string => {
    if (!expression) return "";
    const values = expression.split("#");
    if (values.length > 2) {
        if (values[0] === "row") {
            const rowNumber = values[1];
            const row = rowItems.find((r) => r.id === rowNumber);
            if (!row) return "";
            const field = values[2];
            const col = cols.find((c) => c.field === field);
            if (!col) return "";
            return `${row.title}, ${col.title || col.field}`;
        }
    }
    return "";
};

interface IFormDesignerInitializeFromRowDialogProps {
    cols: ITaskTypeCol[];
    taskTypeCol: ITaskTypeCol;
    onSave: (defaultExpression: string) => Promise<void>;
    onClose: () => void;
}

export const FormDesignerInitializeFromRowDialog = (props: IFormDesignerInitializeFromRowDialogProps) => {
    const [state, setState] = useState<{ field: string, rowNumber: string }>({ field: "", rowNumber: "-1" });
    const [fields, setFields] = useState<IIdTitleDropdownItem[]>([]);
    const [rows] = useState<IIdTitleDropdownItem[]>(rowItems);

    useEffect(() => {
        const newFields: IIdTitleDropdownItem[] = [];
        for (let i = 0; i < props.cols.length; i++) {
            const col = props.cols[i];
            if (col.dataType !== props.taskTypeCol.dataType) continue;
            newFields.push({ id: col.field, title: col.title || col.field });
        }
        if (props.taskTypeCol.defaultExpression) {
            const values = props.taskTypeCol.defaultExpression.split("#");
            if (values.length > 2) {
                if (values[0] === "row") {
                    setState({
                        rowNumber: values[1],
                        field: values[2]
                    });
                }
            }
        } else if (newFields.length > 0) {
            setState({
                rowNumber: "-1",
                field: newFields[0].id
            });
        }
        setFields(newFields);
    }, []);

    return (
        <Dialog
            id="task-form-designer-component-properties-initialize-from-row-dialog"
            maxWidth="sm"
            title={Translations.FormInitializeFromSavedRowDialog}
            body={
                <>
                    <FormField title={Translations.Row} margin={0}>
                        <IdTitleDropdown
                            selectedId={state.rowNumber}
                            items={rows}
                            onChange={(rowNumber: string) => setState((old) => ({ ...old, rowNumber }))}
                        />
                    </FormField>
                    <FormField title={Translations.FormField}>
                        <IdTitleDropdown
                            selectedId={state.field}
                            items={fields}
                            onChange={(field: string) => setState((old) => ({ ...old, field }))}
                        />
                    </FormField>
                </>
            }
            actions={
                <Box display="flex" justifyContent="flex-end" width="100%">
                    <DialogButtons
                        saveTitle={Translations.OK}
                        removeDisabled={!props.taskTypeCol.defaultExpression}
                        onRemove={() => props.onSave("")}
                        onCancel={props.onClose}
                        onSave={() => props.onSave(`row#${state.rowNumber}#${state.field}`)}
                    />
                </Box>
            }
            onClose={props.onClose}
        />
    );
};
